import PageNumberInput from './PageNumberInput';

export default PageNumberInput;